var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  deserializeError: () => deserializeError,
  errorConstructors: () => import_constructors.errorConstructors,
  serializeError: () => serializeError
});
module.exports = __toCommonJS(src_exports);
var import_constructors = require("./constructors");
const getErrorConstructor = (name) => import_constructors.errorConstructors.get(name) ?? Error;
const commonProperties = [
  {
    property: "name",
    enumerable: false
  },
  {
    property: "message",
    enumerable: false
  },
  {
    property: "stack",
    enumerable: false
  },
  {
    property: "code",
    enumerable: true
  },
  {
    property: "cause",
    enumerable: false
  }
];
function serializeError(subject) {
  const data = {};
  for (const { property } of commonProperties) {
    if (!(property in subject))
      continue;
    data[property] = subject[property];
  }
  return data;
}
function deserializeError(subject) {
  const fn = getErrorConstructor(subject.name);
  const output = new fn();
  for (const { property, enumerable } of commonProperties) {
    if (!(property in subject))
      continue;
    Object.defineProperty(output, property, {
      value: subject[property],
      enumerable,
      configurable: true,
      writable: true
    });
  }
  return output;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  deserializeError,
  errorConstructors,
  serializeError
});
//# sourceMappingURL=index.js.map
